<template>
  <i-modal
    :title="titletemplate"
    :value="value"
    :load="loading"
    @submit="submit"
    @input="$emit('input', $event)"
  >
    <v-row class="mb-0">
      <!-- Input -->
      <v-col cols="12">
        <ValidationProvider
          vid="name"
          :name="$tc('name', 1)"
          rules="required"
          v-slot="{ errors }"
        >
          <v-text-field
            autofocus
            name="name"
            :error-messages="errors[0]"
            v-model="template.name"
            outlined
            color="secondary"
            :label="$tc('name', 1)"
          />
        </ValidationProvider>
      </v-col>
      <!-- Input -->
      <v-col cols="12">
        <ValidationProvider
          vid="description"
          :name="$tc('description', 1)"
          rules=""
          v-slot="{ errors }"
        >
          <v-skeleton-loader
            v-if="loading"
            type="article"
            tile
          ></v-skeleton-loader>
          <label v-if="!loading" for="description">
            {{ $t('description') }}
          </label>
          <vue-editor
            v-if="!loading"
            id="description"
            v-model="template.description"
            :editorToolbar="customToolbar"
          >
          </vue-editor>
          <span class="areaErrors" v-if="errors[0] != '' && errors[0] != null">
            {{ errors[0] }}
          </span>
        </ValidationProvider>
      </v-col>
    </v-row>
  </i-modal>
</template>
<script>
import { VueEditor } from 'vue2-editor'
export default {
  components: {
    VueEditor
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    toEdit: {
      type: [Object],
      default: () => null
    },
    company: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      loading: false,
      template: {
        name: '',
        description: ''
      },
      edit: false,
      customToolbar: [
        [{ header: [] }],
        [
          'bold',
          'italic',
          'underline',
          'strike',
          'blockquote',
          'code',
          'code-block'
        ],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ color: [] }, { background: [] }]
      ]
    }
  },
  methods: {
    /**
     * submit
     * Metodo para edición y creación de una plantilla de proceso productivo
     *
     * Rosana Mendez <rosanamendez5 at gmail.com>
     */
    async submit() {
      if (!this.loading) {
        this.template.company = this.company
        try {
          this.loading = true
          const template = !this.edit
            ? await this.$api.product.template.create({
                form: this.template
              })
            : await this.$api.product.template.edit({
                pk: this.template.pk,
                form: this.template
              })
          this.$emit('done', template.data)
          this.$emit('input', false)
          this.$toast.success(
            `${this.$t('template')} ${this.$tc(
              this.edit ? 'edited' : 'created',
              1
            )}`
          )
        } finally {
          this.loading = false
        }
      }
    }
  },
  computed: {
    titletemplate() {
      return this.$t(this.toEdit !== null ? 'editing' : 'add', {
        value: this.$t('template')
      })
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val) {
          this.load = false
          this.edit = this.toEdit !== null
          this.template =
            this.toEdit !== null
              ? { ...this.toEdit }
              : { name: '', description: '' }
        }
      }
    }
  }
}
</script>
